import z from "zod";
import { ZodSchema } from "@validation/utils/schemaUtils";
import { TransactionType, VatCodeType, VatRelation } from "__generated__/enums";

export const vatCodeSchema = z.object({
	id: z.number().nullable(),
	code: ZodSchema.requiredField(z.number().min(0).max(999999999999999)),
	description: z.string().min(1).max(255),
	percentage: ZodSchema.requiredField(z.number().min(0).max(100)),
	type: z.enum(VatCodeType),
	transactionType: z.enum(TransactionType),
	allocation: z.enum(VatRelation),
});

export type VatCodeSchemaInput = z.input<typeof vatCodeSchema>;
export type VatCodeSchemaOutput = z.output<typeof vatCodeSchema>;

export const vatCodeSelectOptionSchema = z.object({
	id: z.number(),
	label: z.string().nullable().optional(),
	allocation: z.enum(VatRelation).nullable().optional(),
	percentage: z.number().nullable().optional(),
});
